import {
    GET_CATEGORY_CAKES_START,
    GET_CATEGORY_CAKES_SUCCESS,
    GET_CATEGORY_CAKES_FAIL,
    GET_STORES_DISTANCE_START,
	GET_STORES_DISTANCE_SUCCESS,
	GET_STORES_DISTANCE_FAIL
} from '../constants/ActionCategoryTypes';

const initialState = {
    loading: false,
    data: null,
    error: false,
};

const CategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATEGORY_CAKES_START:
            return { ...state, loading: true };
        case GET_CATEGORY_CAKES_FAIL:
            return { ...state, loading: false, error: true };
        case GET_CATEGORY_CAKES_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_STORES_DISTANCE_START:
            return { ...state, loading: true };
        case GET_STORES_DISTANCE_FAIL:
            return { ...state, loading: false, error: true };
        case GET_STORES_DISTANCE_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        default:
            return state;
    }
};



export default CategoryReducer